import lottie from "lottie-web";
import { defineElement } from "@lordicon/element";
defineElement(lottie.loadAnimation);

const NoResults = () => {

    return (
        <div className="py-4 text-center">
            <lord-icon
                src="https://cdn.lordicon.com/msoeawqm.json"
                trigger="loop"
                colors="primary:#405189,secondary:#0ab39c"
                style={{ width: "72px", height: "72px" }}
            />
            <div className="mt-4">
                <h5>Sorry! No Result Found</h5>
            </div>
        </div>
    );
}

export default NoResults;